import { useAtomValue } from "jotai";

import {
  articleFloatingButtonAtom,
  defaultFloatingButtonAtom,
} from "scmp-app/lib/floating-button/atoms";

export const useFloatingButtonConfig = (entityId: string) => {
  const { articleFloatingButton } = useAtomValue(articleFloatingButtonAtom);
  const linkConfig =
    articleFloatingButton[entityId] ?? defaultFloatingButtonAtom.articleFloatingButton[entityId];
  return {
    hideLabelInMobile: linkConfig?.hideLabelInMobile ?? true,
    isEnable: linkConfig?.isEnable ?? false,
    tooltipLabel: linkConfig?.tooltipLabel ?? "",
    type: linkConfig?.type ?? "popup",
    typeformLink: linkConfig?.typeformLink ?? "",
  };
};
